import { Reveal, Eyebrow } from "./Reveal";
import { SectionMedia } from "./SectionMedia";
import { useApp } from "../store";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1738762972597-9251e0e4994e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxmcmVuY2glMjBwb2x5bmVzaWElMjBsYWdvb24lMjB0YWhpdGklMjBhZXJpYWwlMjBvY2VhbnxlbnwwfHx8fDE3ODkxNzgzMTZ8MA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  const { c, t } = useApp();
  const chapters = [1, 2, 3].map((n) => ({
    num: `0${n}`,
    title: c(`chapter_${n}_title`),
    text: c(`chapter_${n}_text`),
  }));

  return (
    <section id="cabinet" data-testid="about-section" className="relative text-white grain" style={{ background: "var(--sec-cabinet-bg, #0A1428)" }}>
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32 relative z-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20">
          <div className="lg:sticky lg:top-28 self-start">
            <Reveal>
              <Eyebrow light>{t("about_eyebrow")}</Eyebrow>
              <h2 data-testid="about-title" className="mt-5 font-display font-semibold text-2xl sm:text-3xl lg:text-4xl leading-[1.15] tracking-tight">
                {c("about_title")}
              </h2>
              <p data-testid="about-text" className="mt-6 text-base sm:text-lg text-white/70 leading-relaxed max-w-xl">
                {c("about_text")}
              </p>
              <div data-testid="about-mission-card" className="mt-8 bg-[#12254D] border-l-4 border-[var(--accent)] p-6 max-w-xl">
                <p className="font-mono2 text-[11px] uppercase tracking-[0.25em] text-[var(--accent-soft)] mb-2">
                  {c("mission_title")}
                </p>
                <p data-testid="about-mission-text" className="text-sm sm:text-base text-white/75 leading-relaxed">
                  {c("mission_text")}
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.15} className="mt-10">
              <div className="relative">
                <div className="absolute -top-3 -left-3 w-full h-full border border-[var(--accent-soft)]/40 pointer-events-none" />
                <img
                  src={c("about_image") || ABOUT_IMG}
                  alt="Montagnes de Tahiti"
                  loading="lazy"
                  className="relative w-full h-64 sm:h-80 object-cover"
                />
                <span className="absolute bottom-4 left-4 bg-[#0B132B]/85 backdrop-blur px-4 py-2 font-mono2 text-[10px] uppercase tracking-[0.3em] text-white">
                  Papeete — Tahiti
                </span>
              </div>
            </Reveal>
          </div>

          <div className="flex flex-col">
            {chapters.map((ch, i) => (
              <Reveal key={ch.num} delay={i * 0.08}>
                <article
                  data-testid={`manifesto-chapter-${i + 1}`}
                  className="group border-t border-[var(--accent-soft)]/15 py-10 first:border-t-0 first:pt-0 lg:first:pt-10 lg:first:border-t"
                >
                  <div className="flex items-start gap-6 sm:gap-10">
                    <span className="font-mono2 text-sm text-[var(--accent-soft)] pt-2">{ch.num}</span>
                    <div>
                      <h3 className="font-display font-semibold text-xl sm:text-2xl transition-transform duration-500 group-hover:translate-x-2">
                        {ch.title}
                      </h3>
                      <p className="mt-3 text-sm sm:text-base text-white/65 leading-relaxed max-w-md">
                        {ch.text}
                      </p>
                    </div>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>

        <SectionMedia section="cabinet" light />
      </div>
    </section>
  );
};
